import { Pipe, PipeTransform } from '@angular/core';
import { HOLD } from 'ngrx/status-types';

import { ActivityHistory } from '../../models';

@Pipe({
  name: 'dpoHoldReason'
})
export class DpoHoldReasonPipe implements PipeTransform {
  transform(records: ActivityHistory[]) {
    if (!records) return '';
    let dpoHoldreason = records.sort(({ timestamp: t1 }, { timestamp: t2 }) => +t2 - +t1).find(ah => ah.activity === 'DPO_HOLD');

    return dpoHoldreason != null ? dpoHoldreason.note : '';
  }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes/dpo-hold-reason.pipe.ts